import tw from 'twin.macro';

import { HEADER_HEIGHT, TABLE_CONTROLLER_HEIGHT } from '@components/Header';

const Background = tw.div`min-h-screen flex flex-col justify-center items-center bg-no-repeat bg-cover bg-center bg-fixed bg-primary text-primary`;
const AbsoluteCardContainer = tw.div`absolute flex justify-center items-center min-w-full min-h-full top-0`;
const Absolute = tw.div`absolute top-0 left-0 bottom-0 right-0 bg-page-background`;
const Card = tw.div`absolute w-full min-h-screen md:min-h-0 flex flex-col justify-start items-center bg-secondary md:rounded-lg px-10 py-5 md:px-20 md:py-10 md:border md:border-light-purple`;

const Layout = ({ children, ...props }: { children: React.ReactNode }) => {
  return (
    <Layout.Background>
      <Layout.Card {...props}>{children}</Layout.Card>
    </Layout.Background>
  );
};

const LayoutCard = ({ children, ...props }: { children: React.ReactNode }) => {
  return (
    <AbsoluteCardContainer>
      <Card {...props}> {children} </Card>
    </AbsoluteCardContainer>
  );
};

const UsersTableWrapper = ({ children, ...props }: { children: React.ReactNode }) => {
  return (
    <Absolute
      css={{
        top: `${HEADER_HEIGHT + TABLE_CONTROLLER_HEIGHT}px`,
        overflowY: 'scroll',
      }}
      {...props}>
      {children}
    </Absolute>
  );
};

Layout.displayName = 'Layout';
Layout.Background = Background;
Layout.Card = LayoutCard;
Layout.UsersTableWrapper = UsersTableWrapper;

export { Layout };
